import React, { useState, useEffect, useCallback } from 'react';
import './styles.scss';
import { NotificationManager } from "react-notifications";
import { MdSettings, MdClose } from "react-icons/md";
import { useStyles } from './styles';
import { MdAdd, MdArrowBack, MdArrowForward, MdCheck } from 'react-icons/md';
import { PlanConfig, ActionConfig } from '../../../Plugin/component'
import { useHistory, useParams } from 'react-router-dom';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import { TwinSpin } from "react-cssfx-loading";
import { SERVER_API_PRIVITE } from "../../../../config.json";

function getDefaultPlanConfig() {
    return [
        { colunmName: "Nhân viên phụ trách", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "6", disabled: true, editFrom: "Main" },
        { colunmName: "Phân công xử lý", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "6", disabled: true, editFrom: "Step" },

        //Fix Cứng donmain private stag
        //{ colunmName: "Nhân viên phụ trách", colunmType: "Multiple select", colunmData: ["http://itsm-api-dev/itsm/api/User/GetEmail"], colunmWidth: "6", disabled: true, editFrom: "Main" },
        //{ colunmName: "Phân công xử lý", colunmType: "Multiple select", colunmData: ["http://itsm-api-dev/itsm/api/User/GetEmail"], colunmWidth: "6", disabled: true, editFrom: "Step" },

    ]
}

function getPlanConfigNew() {
    return [{ colunmName: "", colunmType: "", colunmData: [], colunmWidth: "", disabled: false, editFrom: "Step", configTypeID: 0, isRequired: "false" }];
}
function getDefaultConfigAddTimeDeploy() {
    return [
        { colunmName: "Lý do gia hạn thời gian triển khai", colunmType: "Input text multiline", colunmData: [], colunmWidth: "6", disabled: false, editFrom: "Step", configTypeID: 0, isRequired: "false" },
        { colunmName: "Thời gian gia hạn triển khai", colunmType: "Datetime", colunmData: [], colunmWidth: "6", disabled: false, editFrom: "Step", configTypeID: 0, isRequired: "false" }
    ];
}

function getStepContent(stepIndex, handle, feeds) {
    return <BodyPlanConfigByStep
        feeds={feeds}
        stepIndex={stepIndex}
        value={handle.HandlePlanConfig.value}
        onClickDelete={handle.HandlePlanConfig.fn.btnDeleteConfig}
        onClickUp={handle.HandlePlanConfig.fn.btnUpConfig}
        onClickDown={handle.HandlePlanConfig.fn.btnDownConfig}
        onClick={handle.HandlePlanConfig.fn.btnAddConfigDataClick}
        onChange={handle.HandlePlanConfig.fn.InputOnchange}
        onDragDrop={handle.HandlePlanConfig.fn.handleDragDrop}
        onClickCopy={handle.HandlePlanConfig.fn.btnCopyConfig}
    />;
}

const FeedsDefault = [
    "[[Nhân viên phụ trách - bước tiếp theo]]", "[[Nhân viên phụ trách - bước trước đó]]",
    "[[Phân công xử lý - bước tiếp theo]]", "[[Phân công xử lý - bước trước đó]]",
    "[[Bước hiện tại]]", "[[Bước tiếp theo]]", "[[Bước trước đó]]",
    "[[Tên Bước hiện tại]]", "[[Tên Bước tiếp theo]]", "[[Tên Bước trước đó]]",
    "[[Toàn bộ nhân viên phụ trách]]", "[[Toàn bộ nhân viên xử lý]]",
    "[[Người tạo]]", "[[Kế hoạch]]", "[[User thao tác]]",
    "[[Phân công xử lý]]", "[[Nhân viên phụ trách]]",
    //ticket new
    "[[PhaseID]]", "[[Ảnh hưởng khách hàng]]", "[[Số lượng ảnh hưởng]]",
    "[[Số lượng khách hàng PayTV]]",
    "[[Tên hạn mục]]",
    "[[Tên dịch vụ]]",
    //ticket close
    "[[Đơn vị tạo]]", "[[Mã ID Ticket]]", "[[TicketCode]]",
    "[[ID đóng]]",
    //ticket confirm
    "[[ID duyệt]]",
    //Email Confirm
    "[[Link xác nhận]]",
    //Email Reject
    "[[Link từ chối]]"
]

function getFeedsData(planConfig) {

    const FeedsData = [...FeedsDefault];
    for (let i = 0; i < planConfig.length; i++) {
        FeedsData.push(`[[${planConfig[i].colunmName}]]`);
    }

    const FeedsDataDisplay = [];

    for (let i = 0; i < FeedsData.length; i++) {
        FeedsDataDisplay.push({
            id: i, display: FeedsData[i]
        });
    }

    return { feedsDataDisplay: FeedsDataDisplay, feedsData: FeedsData };
}

function BodyPlanConfigByStep(props) {
    const BodyPlanConfigByStepValue = props.value.filter((item) => item.step === props.stepIndex + 1)[0];
    // let actionStep = BodyPlanConfigByStepValue && BodyPlanConfigByStepValue.actions.filter((item) => item.component === 'ADD_TIME_DEPLOY' && item.checked);
    // let bodyStep = { ...BodyPlanConfigByStepValue };
    // if (actionStep && actionStep.length > 0) {
    //     let configStep = BodyPlanConfigByStepValue.config;
    //     bodyStep.config = configStep.concat(getDefaultConfigAddTimeDeploy());
    // }
    // console.log("BodyPlanConfigByStepValue", bodyStep);
    return <div className="body-plan-config-by-step">
        <div className="row plan-name">
            <div className="col-md-12">
                <TextField
                    className="col-md-4"
                    fullWidth
                    id="outlined-name"
                    label="Tên bước thực hiện"
                    margin="dense"
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(e) => props.onChange(e, props.stepIndex, "", "name")}
                    value={BodyPlanConfigByStepValue?.name}
                />
            </div>
        </div>
        <div className="row operation">
            <div className="col-md-12">
                <div className="title-operation">Thao tác</div>
                <div className="body-operation">
                    {BodyPlanConfigByStepValue && BodyPlanConfigByStepValue?.actions.map((item, index) => {
                        return <ActionConfig key={index} feeds={props.feeds} status="INIT" propsJson={typeof item.propsJson === "string" ? JSON.parse(item.propsJson) : item.propsJson} dependentActions={item.dependentActions} type={item.component} label={item.name} checked={item.checked} onChange={(e) => props.onChange(e, props.stepIndex, index, "operation")} />
                    })}
                </div>
            </div>
        </div>
        <PlanConfig
            onClickDeleteGeneral={(index) => props.onClickDelete(index, props.stepIndex)}
            onClickUp={(index) => props.onClickUp(index, props.stepIndex)}
            onClickDown={(index) => props.onClickDown(index, props.stepIndex)}
            onClickGeneral={() => props.onClick(props.stepIndex)}
            onChangeGeneral={(e, index, key) => props.onChange(e, props.stepIndex, index, key)}
            valueGeneral={props.value.filter((item) => item.step === props.stepIndex + 1)[0]?.config}
            // onDragDrop={(values) => props.onDragDrop(values)}
            onDragDrop={props.onDragDrop}
            currentStep={props.value[0].step}
            onClickCopy={(index) => props.onClickCopy(index, props.stepIndex)}
        />
    </div>
}

export default function PlanConfigByStepComponent(props) {

    const [steps, setsteps] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [bodySteps, setbodySteps] = useState();
    const [openEditStep, setOpenEditStep] = useState(false);
    const [feeds, setFeeds] = useState();
    const history = useHistory();
    const classes = useStyles();
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [configStep, setConfigStep] = useState([]);
    const [isActive, setActive] = useState(0);
    useEffect(() => {
        if (!history.location.state) {
            history.push({ pathname: "/PlanTemplate/new" })
        }
        else {
            props.GetDataPlanConfigByStep(history.location.state.id, history.location.state.stepNumberPerform);
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (history && history.location.state.bodySteps && history.location.state.feeds && history.location.state.steps) {
            setsteps(history.location.state.steps)
            setbodySteps(history.location.state.bodySteps)
            setFeeds(history.location.state.feeds)
        } else if (props.DataPlanConfigByStep) {
            setsteps(() => {
                return props.DataPlanConfigByStep.map((item) => {
                    return item.stepName
                })
            });
            setbodySteps(() => {
                return props.DataPlanConfigByStep.map((item) => {
                    const planTypeConfiguration = item.planTypeConfiguration.map((item1) => {
                        return { colunmName: item1.name, colunmType: item1.type, colunmData: item1.data.split('*'), colunmWidth: item1.flex.toString(), disabled: item1.disabled, editFrom: item1.editFrom, configTypeID: item1.configTypeID, isRequired: item1.isRequired === "true" ? "true" : "false" }
                    });
                    return { step: item.step, name: item.stepName, actions: item.actions, config: planTypeConfiguration }
                })
            });
            let FeedsData = [...history.location.state.planConfig]
            if (bodySteps) {
                // eslint-disable-next-line
                FeedsData = [...FeedsData, ...bodySteps.filter(item => { return item.step == activeStep + 1 })[0].config]
            }
            setFeeds(getFeedsData(FeedsData))
        }
    // eslint-disable-next-line
    }, [props.DataPlanConfigByStep])

    useEffect(() => {
        if (props.isResult) {
            NotificationManager.success("Thêm template kết hoạch thành công");
            props.GetDataLayout();
            history.push({ pathname: "/PlanTemplate/main" })
        }
        setIsLoading(false)
        // eslint-disable-next-line
    }, [props.isResult])


    useEffect(() => {
        if (bodySteps) {
            let t = []
            // eslint-disable-next-line
            bodySteps.map((item) => {
                // eslint-disable-next-line
                item.config.filter(item => { return item.editFrom === "Step" && item.colunmName !== "Phân công xử lý" }).map((item) => {
                    t.push(item)
                });
            });
            let actionStep = bodySteps && bodySteps[activeStep].actions.filter((item) => item.component === 'ADD_TIME_DEPLOY' && item.checked);
            let configStep = bodySteps && bodySteps[activeStep].config.filter((item) => item.colunmName === 'Lý do gia hạn thời gian triển khai' || item.colunmName === 'Thời gian gia hạn triển khai');
            if((isActive === 0 || isActive ===2) && (actionStep && actionStep.length > 0) && (configStep && configStep.length === 0)){
                let configsStep = bodySteps[activeStep].config.concat(getDefaultConfigAddTimeDeploy());
                setConfigStep(configsStep);
                setActive(1);
            }
            else if(isActive === 0 && (actionStep && actionStep.length === 0) && (configStep && configStep.length > 0) ){
                let configsStep = bodySteps[activeStep].config.filter((item) => item.colunmName !== 'Lý do gia hạn thời gian triển khai' && item.colunmName !== 'Thời gian gia hạn triển khai');
                setConfigStep(configsStep);
                setActive(2);
            }
            else if(isActive === 0 && (actionStep && actionStep.length === 0) ){
                // let configsStep = bodySteps[activeStep].config.filter((item) => item.colunmName !== 'Lý do mở thêm thời gian triển khai');
                // setConfigStep(configsStep);
                setActive(0);
            }
            else if(isActive === 1 && actionStep && actionStep.length === 0){
                let configsStep = bodySteps[activeStep].config.filter((item) => item.colunmName !== 'Lý do gia hạn thời gian triển khai' && item.colunmName !== 'Thời gian gia hạn triển khai');
                setConfigStep(configsStep);
                setActive(2);
            }
            for (var i = 1; i <= props.DataPlanConfigByStep.length; i++) {
                t.push({ colunmName: "Nhân viên phụ trách bước__" + i, editFrom: "Main", })
                t.push({ colunmName: "Phân công xử lý bước__" + i, editFrom: "Main", })
            }
            setFeeds(getFeedsData([...history.location.state.planConfig, ...t]))
        }
        // eslint-disable-next-line
    }, [bodySteps, activeStep])

    useEffect(() =>{
        if(isActive === 1)
        {
            setbodySteps([...bodySteps.slice(0, activeStep),
                {
                    ...bodySteps[activeStep],
                    config: configStep,
                },
                ...bodySteps.slice(activeStep + 1)])
            //setActive(0);
        }
        else if(isActive === 2){
            setbodySteps([...bodySteps.slice(0, activeStep),
                {
                    ...bodySteps[activeStep],
                    config: configStep,
                },
                ...bodySteps.slice(activeStep + 1)])
        }
        // eslint-disable-next-line
    }, [isActive])

    const handleNext = () => {
        const DataConfigStep = bodySteps.filter((item) => { return item.step === activeStep + 1 })[0];
        const DataConfigStepOperation = DataConfigStep.actions.filter((item) => { return item.checked });
        if (DataConfigStep.name === "") {
            NotificationManager.error(`Vui lòng tên bước thực hiện tại bước số ${DataConfigStep.step}.`);
            return false;
        }
        if (DataConfigStepOperation.length < 1) {
            NotificationManager.error(`Vui lòng chọn ít nhất 1 thao tác tại bước số ${DataConfigStep.step}.`);
            return false;
        }
        let DataItemPlanConfig = DataConfigStep.config.filter((item) => { return item.colunmName })
        let DataItemPlanConfigFail = DataItemPlanConfig.filter((item) => { return !item.colunmType || !item.colunmWidth })
        let DataItemPlanConfigComboboxFail = DataItemPlanConfig.filter((item) => { return (item.colunmType === "Combobox" || item.colunmType === "Multiple select") && item.colunmData.length < 1 })
        if (DataItemPlanConfig.length < 1 || DataItemPlanConfigFail.length > 0 || DataItemPlanConfigComboboxFail.length > 0) {
            NotificationManager.error(`Vui lòng nhập đủ thông tin ở bước số ${DataConfigStep.step}.`);
            return false;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleComplete = () => {
        const DataConfig = [...bodySteps];
        let DataConfigNameFail = DataConfig.filter((item) => { return !item.name })

        if (DataConfigNameFail.length > 0) {
            NotificationManager.error(`Vui lòng tên bước thực hiện tại bước số ${DataConfigNameFail[0].step}.`);
            return false;
        }

        let DataConfigNameOperation = DataConfig.filter((item) => {
            const DataConfigStepOperation = item.actions.filter((item1) => { return item1.checked });
            return DataConfigStepOperation.length < 1
        })

        if (DataConfigNameOperation.length > 0) {
            NotificationManager.error(`Vui lòng chọn ít nhất 1 thao tác tại bước số ${DataConfigNameOperation[0].step}.`);
            return false;
        }

        let Config = true;

        DataConfig.every((item) => {
            let DataItemPlanConfig = item.config.filter((item1) => { return item1.colunmName })
            let DataItemPlanConfigFail = DataItemPlanConfig.filter((item1) => { return !item1.colunmType || !item1.colunmWidth })
            let DataItemPlanConfigComboboxFail = DataItemPlanConfig.filter((item1) => { return (item1.colunmType === "Combobox" || item1.colunmType === "Multiple select") && item1.colunmData.length < 1 })

            if (DataItemPlanConfig.length < 1 || DataItemPlanConfigFail.length > 0 || DataItemPlanConfigComboboxFail.length > 0) {
                NotificationManager.error(`Vui lòng nhập đủ thông tin ở bước số ${item.step}.`);
                Config = false;
                return false;
            }
            return true;
        })

        if (!Config) {
            return false;
        }

        HandleLoadingPage()

        const Data = DataConfig.map((item) => {
            return {
                Step: item.step,
                StepName: item.name,
                Actions: item.actions,
                PlanTypeConfiguration: item.config.filter((item1) => { return item1.colunmName }).map((item1) => { return { Name: item1.colunmName, Type: item1.colunmType, Flex: item1.colunmWidth ? item1.colunmWidth : "0", Data: item1.colunmData ? item1.colunmData.join("*") : "", EditFrom: item1.editFrom, ConfigTypeID: item1.configTypeID, IsRequired: item1.isRequired } })
            }
        })

        const planTypeConfiguration = [
            ...history.location.state.planConfig,
            ...history.location.state.filterConfig
        ]

        // props.SetDataPlanConfigByStep({
        //     ID: history.location.state.id, Name: history.location.state.planName, StepNumber: history.location.state.stepNumberPerform, PlanTypeConfigurationMain: [
        //         {
        //             Step: 0,
        //             StepName: "",
        //             PlanTypeConfiguration: history.location.state.planConfig.filter((item) => { return item.colunmName }).map((item) => { return { Name: item.colunmName, Type: item.colunmType, Flex: item.colunmWidth ? item.colunmWidth : "0", Data: item.colunmData ? item.colunmData.join("*") : "", EditFrom: item.editFrom, IsRequired: item.isRequired, ConfigTypeID: item.configTypeID } }),
        //         },
        //         ...Data
        //     ]
        // });

        // console.log("ID", history.location.state.id, "Name", history.location.state.planName, "UserCOde", history.location.state.dataManager, "historyOn", history.location.state.cbACtionHistory, "PlanTypeConfigurationMain", [
        //     {
        //         Step: 0,
        //         StepName: "",
        //         Page: history.location.state.pageReport,
        //         PlanTypeConfiguration: planTypeConfiguration.filter((item) => { return item.colunmName }).map((item) => {
        //             return {
        //                 Name: item.colunmName, Type: item.colunmType,
        //                 Flex: item.colunmWidth ? item.colunmWidth : "0", 
        //                 Data: item.colunmData ? (item.colunmType === 'Link liên kết' ? item.colunmData : (item.colunmType ==='Combobox' || item.colunmType === 'Multiple select' ? item.colunmData.join('*'): item.colunmData)) : "",
        //                 EditFrom: item.editFrom, IsRequired: item.isRequired, Rename: item.colunmNewName,
        //                 KT: item.KT, refName: item.refName,
        //                 ConfigTypeID: item.configTypeID, PinColumn: item.pinColunm === true ? item.pinColunm : false
        //                 , input: item.input ? item.input : []
        //                 , output: item.output ? item.output.filter((items) => { return items.colunmName }).map((items) => {

        //                     return {
        //                         Name: items.colunmName, Type: items.colunmType,
        //                         Flex: items.colunmWidth ? items.colunmWidth : "0", Data: items.colunmData ? items.colunmData : "",
        //                         value: items.value,
        //                         EditFrom: items.editFrom, IsRequired: items.isRequired, Rename: items.colunmNewName,
        //                         ConfigTypeID: items.configTypeID, PinColumn: items.pinColunm === true ? items.pinColunm : false
        //                     }
        //                 }) : []
        //             }
        //         }),
        //     },
        //     ...Data
        // ] )
        props.SetDataPlanConfigByStep({
            ID: history.location.state.id, Name: history.location.state.planName, StepNumber: history.location.state.stepNumberPerform, UserCodes: history.location.state.dataManager, historyOn: history.location.state.cbACtionHistory, IsValidateDate: history.location.state.IsValidateDate, PlanTypeConfigurationMain: [
                {
                    Step: 0,
                    StepName: "",
                    Page: history.location.state.pageReport,
                    PlanTypeConfiguration: planTypeConfiguration.filter((item) => { return item.colunmName }).map((item) => {
                        return {
                            Name: item.colunmName, Type: item.colunmType,
                            Flex: item.colunmWidth ? item.colunmWidth : "0",
                            Data: item.colunmData ? (item.colunmType === 'Link liên kết' ? item.colunmData : (typeof item.colunmData === 'string' ? item.colunmData : item.colunmData.join('*'))) : "",
                            EditFrom: item.editFrom, IsRequired: item.isRequired, Rename: item.colunmNewName,
                            KT: item.KT, refName: item.refName,
                            ConfigTypeID: item.configTypeID, PinColumn: item.pinColunm === true ? item.pinColunm : false
                            , input: item.input ? item.input : []
                            , output: item.output ? item.output.filter((items) => { return items.colunmName }).map((items) => {

                                return {
                                    Name: items.colunmName, Type: items.colunmType,
                                    Flex: items.colunmWidth ? items.colunmWidth : "0", Data: items.colunmData ? items.colunmData : "",
                                    value: items.value,
                                    EditFrom: items.editFrom, IsRequired: items.isRequired, Rename: items.colunmNewName,
                                    ConfigTypeID: items.configTypeID, PinColumn: items.pinColunm === true ? items.pinColunm : false
                                }
                            }) : []
                        }
                    }),
                },
                ...Data
            ]
        });
    };

    const HandleLoadingPage = useCallback(() => {
        setIsLoading(true)
        // eslint-disable-next-line
    }, [props.SetDataPlanConfigByStep])

    const handleBack = () => {
        if (activeStep === 0) {
            const { state } = history.location
            const newState = { state, bodySteps: bodySteps, feeds, steps }
            history.push({ pathname: `/PlanTemplate/Edit/${id}`, ...newState })
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const HandleAddConfigData = (step) => {
        let LastItem = bodySteps.filter((item) => item.step === step + 1)[0].config.filter((item, index) => {
            return index === bodySteps.filter((item) => item.step === step + 1)[0].config.length - 1;
        });
        if (LastItem[0].colunmName !== "") {
            setbodySteps([...bodySteps.slice(0, step),
            {
                ...bodySteps[step],
                config: [...bodySteps[step].config, ...getPlanConfigNew()],
            },
            ...bodySteps.slice(step + 1)])
        }
        else {
            NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
        }

    }

    const HandlePlanConfigDelete = (index, step) => {
        if (bodySteps[step].config.length > 1) {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }

    const HandlePlanConfigUp = (index, step) => {
        if (bodySteps[step].config.length > 1 && index > 0) {
            let planConfigCopy = [...bodySteps[step].config];
            let itemWithIndex = planConfigCopy[index];

            planConfigCopy[index] = planConfigCopy[index - 1];
            planConfigCopy[index - 1] = itemWithIndex;

            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [...planConfigCopy]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandlePlanConfigDown = (index, step) => {
        if (bodySteps[step].config.length > 1 && index < bodySteps[step].config.length - 1) {
            let planConfigCopy = [...bodySteps[step].config];
            let itemWithIndex = planConfigCopy[index];

            planConfigCopy[index] = planConfigCopy[index + 1];
            planConfigCopy[index + 1] = itemWithIndex;

            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [...planConfigCopy]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandleDragDrop = (ArrayDragDrop) => {
        // eslint-disable-next-line
        const { values, type } = ArrayDragDrop;
        const planConfigCopy = values.map((item) => item.content.props.value);
        setbodySteps([
            ...bodySteps.slice(0, activeStep),
            {
                ...bodySteps[activeStep],
                config: [...planConfigCopy]
            },
            ...bodySteps.slice(activeStep + 1)
        ])
    };

    const HandleAInputOnchange = (e, step, index, key) => {
        if (key === "name") {
            setsteps([...steps.slice(0, step), e.target.value ? e.target.value : "...", ...steps.slice(step + 1)])
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    name: e.target.value,
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "operation") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    actions: [
                        ...bodySteps[step].actions.slice(0, index),
                        {
                            ...bodySteps[step].actions[index],
                            checked: e.checked,
                            dependentActions: e.dependentActions,
                            propsJson: e.propsJson
                        },
                        ...bodySteps[step].actions.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "operation.confirm") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    operation: { ...bodySteps[step].operation, confirm: e.target.checked }
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "operation.cancel") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    operation: { ...bodySteps[step].operation, cancel: e.target.checked }
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "operation.close") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    operation: { ...bodySteps[step].operation, close: e.target.checked }
                },
                ...bodySteps.slice(step + 1)
            ])
        } else if (key === "colunmName") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            colunmName: e.target.value,
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "colunmType") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            colunmType: e,
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "colunmData") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            colunmData: e,
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "colunmWidth") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            colunmWidth: e,
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
        else if (key === "isAvailabelDisplay") {
            const configTypeReport = 4
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            configTypeID: e === "Enable" ? configTypeReport : 0,
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        } else if (key === "isRequired") {
            setbodySteps([
                ...bodySteps.slice(0, step),
                {
                    ...bodySteps[step],
                    config: [
                        ...bodySteps[step].config.slice(0, index),
                        {
                            ...bodySteps[step].config.slice(index)[0],
                            isRequired: e ? "true" : "false",
                        },
                        ...bodySteps[step].config.slice(index + 1),
                    ]
                },
                ...bodySteps.slice(step + 1)
            ])
        }
    }

    const HandleOpenEdit = () => {
        setOpenEditStep(!openEditStep);
    }

    const HandleAddStepBefore = () => {
        setOpenEditStep(!openEditStep);
        setsteps([
            ...steps.slice(0, activeStep),
            "...",
            ...steps.slice(activeStep)
        ])
        const dependentActions_Tamp = bodySteps[0].actions[0].dependentActions.map(item => { return { actionID: item.actionID, component: item.component, name: item.name } });
        const bodySteps_Tamp = [
            ...bodySteps.slice(0, activeStep),
            {
                name: "",
                config: getDefaultPlanConfig(),
                actions: bodySteps[0].actions.map(item => { return { actionID: item.actionID, component: item.component, name: item.name, dependentActions: dependentActions_Tamp } })
            },
            ...bodySteps.slice(activeStep)
        ]
        setbodySteps(() => bodySteps_Tamp.map((item, index) => { return { step: index + 1, name: item.name, actions: item.actions, config: item.config } }))
    }
    const HandleAddStepAfter = () => {
        setOpenEditStep(!openEditStep);
        setsteps([
            ...steps.slice(0, activeStep + 1),
            "...",
            ...steps.slice(activeStep + 1)
        ])
        const dependentActions_Tamp = bodySteps[0].actions[0].dependentActions.map(item => { return { actionID: item.actionID, component: item.component, name: item.name } });
        const bodySteps_Tamp = [
            ...bodySteps.slice(0, activeStep + 1),
            {
                name: "",
                config: getDefaultPlanConfig(),
                actions: bodySteps[0].actions.map(item => { return { actionID: item.actionID, component: item.component, name: item.name, dependentActions: dependentActions_Tamp } })
            },
            ...bodySteps.slice(activeStep + 1)
        ]
        setbodySteps(() => bodySteps_Tamp.map((item, index) => { return { step: index + 1, name: item.name, actions: item.actions, config: item.config } }))
    }

    const HandleDeleteStep = () => {
        setOpenEditStep(!openEditStep);
        setsteps([
            ...steps.slice(0, activeStep),
            ...steps.slice(activeStep + 1)
        ])
        const bodySteps_Tamp = [
            ...bodySteps.slice(0, activeStep),
            ...bodySteps.slice(activeStep + 1)
        ]
        if (activeStep === bodySteps_Tamp.length) {
            setActiveStep(activeStep - 1)
        }
        setbodySteps(() => bodySteps_Tamp.map((item, index) => { return { step: index + 1, name: item.name, actions: item.actions, config: item.config } }))
    }

    const HandleStepChange = (step) => {
        setActiveStep(step);
    }

    const HandleCopyConfig = (indexItem) => {
        // if (bodySteps[step].config.length > 1 && index < bodySteps[step].config.length - 1) {
        const planConfigCopy = [...bodySteps[activeStep].config];
        const valuePlanConfig = planConfigCopy.filter((item, index) => {
            return index === indexItem
        })
        const newPlanCofig = [
            ...planConfigCopy.slice(0, indexItem),
            ...valuePlanConfig,
            ...valuePlanConfig,
            ...planConfigCopy.slice(indexItem + 1)
        ]
        setbodySteps([
            ...bodySteps.slice(0, activeStep),
            {
                ...bodySteps[activeStep],
                config: [...newPlanCofig]
            },
            ...bodySteps.slice(activeStep + 1)
        ])
    }
    const HandleConfig = {
        "HandlePlanConfig": {
            "fn": {
                "btnAddConfigDataClick": HandleAddConfigData,
                "InputOnchange": HandleAInputOnchange,
                "btnDeleteConfig": HandlePlanConfigDelete,
                "btnUpConfig": HandlePlanConfigUp,
                "btnDownConfig": HandlePlanConfigDown,
                "handleDragDrop": HandleDragDrop,
                "btnCopyConfig": HandleCopyConfig,
            },
            "value": bodySteps
        },
    }

    if (history.location.state.id && !props.DataPlanConfigByStep) {
        return (
            <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                <CircularProgress />
            </div>
        )
    }

    return (
        <div className="plan-config-by-step">
            <div className={classes.root}>
                {!isLoading && <div className="plan-template-step">
                    {history.location.state.id && <IconButton aria-label="delete" onClick={HandleOpenEdit} className="btn-edit">
                        <MdSettings />
                    </IconButton>}
                    {
                        openEditStep ? <div className="plan-template-step-edit">
                            <Button variant="contained" className="btn-next" onClick={HandleAddStepBefore} startIcon={<MdAdd />}>
                                Thêm trước
                            </Button>
                            <Button variant="contained" className="btn-next" onClick={HandleAddStepAfter} startIcon={<MdAdd />}>
                                Thêm sau
                            </Button>
                            <Button style={{ margin: "0 2.5px", background: "#F70", borderColor: "#F70" }} onClick={HandleDeleteStep} variant="contained" className="btn-next" startIcon={<MdClose />}>
                                Xóa bước
                            </Button>
                        </div> : <Stepper activeStep={activeStep} alternativeLabel>
                            {steps && steps.map((label, index) => (
                                <Step className="" key={index} onClick={() => HandleStepChange(index)}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    }
                </div>}
                <div className="plan-template-new-body">
                    {steps && !isLoading && getStepContent(activeStep, HandleConfig, feeds)}
                    {!isLoading && (<div className="action">
                        <Button
                            // disabled={activeStep === 0}
                            onClick={handleBack}
                            className={classes.backButton}
                            variant="contained"
                            startIcon={<MdArrowBack />}
                        >
                            lùi lại
                        </Button>
                        {steps && activeStep === steps.length - 1 ? <Button variant="contained" className="btn-next" onClick={handleComplete} startIcon={<MdCheck />}>
                            Hoàn tất
                        </Button>
                            :
                            <Button variant="contained" className="btn-next" onClick={handleNext} startIcon={<MdArrowForward />}>
                                Tiếp theo
                            </Button>

                        }

                    </div>)}
                    {isLoading && <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                        <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
                    </div>
                    }
                </div>
            </div>
        </div>
    );
}
